// Height of the on-screen keyboard. iOS (especially the home-screen app) sometimes shrinks
// window.innerHeight together with the visual viewport, so we compare against the tallest
// viewport seen while no text box was focused, not just innerHeight.
let base = { w: 0, h: 0 };
export const typing = () => !!document.activeElement?.matches?.("input:not([type=checkbox]):not([type=radio]):not([type=range]):not([type=button]):not([type=submit]):not([type=file]):not([type=color]), textarea, [contenteditable='true']");

export const trackViewport = () => {
  const vv = window.visualViewport;
  const w = window.innerWidth;
  const h = Math.max(window.innerHeight, vv ? vv.height + vv.offsetTop : 0);
  if (w !== base.w) base = { w, h }; // rotation / resize: start over
  else if (!typing() || h > base.h) base.h = Math.max(base.h, h);
};

export default function keyboardInset() {
  const vv = window.visualViewport;
  if (!vv) return 0;
  trackViewport();
  const full = Math.max(window.innerHeight, base.h);
  return Math.max(0, Math.round(full - vv.height - vv.offsetTop));
}

if (typeof window !== "undefined") {
  trackViewport();
  window.addEventListener("resize", trackViewport);
  window.visualViewport?.addEventListener("resize", trackViewport);
}
